import { defineMessages } from 'react-intl';

export const messages: {
	appsSelectedLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	atlassianAppsGroupTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	exploreMoreAppsButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	integrationsAppsGroupTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loadErrorMessage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loadErrorTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	marketplaceAppsGroupTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	moreAppsLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	noResultsMessage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	noResultsTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	moreAppsLabel: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.label',
		description: 'More apps label in the navigation ribbon.',
		defaultMessage: 'More Apps',
	},
	noResultsTitle: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.no-results.message',
		description:
			'Message shown in the more apps component when the user searches but no apps match the filter text.',
		defaultMessage: 'We couldn’t find anything that matches your search',
	},
	noResultsMessage: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.no-results.hint',
		description: 'Message shown under the no results message in the more apps component.',
		defaultMessage: 'Try searching for something else.',
	},
	loadErrorTitle: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.load-error.title',
		description: 'Title shown in the more apps component when the apps data failed to load',
		defaultMessage: 'We couldn’t load more apps',
	},
	loadErrorMessage: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.load-error.message',
		description: 'Message shown in the more apps component when the apps data failed to load',
		defaultMessage: 'Refresh the page and try again',
	},
	appsSelectedLabel: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.apps-selected.label',
		description:
			'Label showing the number of apps selected out of the maximum allowed in the more apps component in the navigation ribbon.',
		defaultMessage: '{count}/{max} apps selected',
	},
	atlassianAppsGroupTitle: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.atlassian-apps-group.title',
		description:
			'Title for the Atlassian apps group in the more apps component in the navigation ribbon.',
		defaultMessage: 'Atlassian apps',
	},
	marketplaceAppsGroupTitle: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.marketplace-apps-group.title',
		description:
			'Title for the Marketplace apps group in the more apps component in the navigation ribbon.',
		defaultMessage: 'Marketplace apps',
	},
	integrationsAppsGroupTitle: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.integrations-apps-group.title',
		description:
			'Title for the Integrations apps group in the more apps component in the navigation ribbon.',
		defaultMessage: 'Integrations',
	},
	exploreMoreAppsButtonLabel: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.explore-more-apps-button.label',
		description:
			'Label for the explore more apps button in the more apps component in the navigation ribbon.',
		defaultMessage: 'Explore more apps',
	},
});
